import { useParams } from 'react-router';

import YouthProtectionPolicyJa from './ja';
import YouthProtectionPolicyKo from './ko';
import YouthProtectionPolicyTh from './th';

const YouthProtectionPolicy = () => {
  const { language = 'ko' } = useParams();

  if (language === 'th') return <YouthProtectionPolicyTh />;
  else if (language === 'ja') return <YouthProtectionPolicyJa />;
  return <YouthProtectionPolicyKo />;
};

export default YouthProtectionPolicy;
